import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { OCmsTable, OConfirmPopup } from '../components/organisme';
import { setCmsHead } from '../redux/head/headActions';
import { fetchDocuments } from '../redux/content/contentActions';
import { removeDocument } from '../redux/cms/cmsActions';
import { CMS_CONFIG } from '../config/cms.config';
import { routes } from '../constants';
import withAuthGuard from '../helpers/withAuthGuard';

const mapStateToProps = state => ({
	items: state.content.documents,
	isFetching: state.content.isFetching,
});

class DocumentOverviewPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [],
			isFetching: true,
			confirmPopupOpen: false,
			deleteName: '',
			pendingDeleteId: undefined,
		};
	}
	componentDidMount() {
		const onClick = `${this.props.match.url}/create`;
		this.props.setCmsHead({ ...CMS_CONFIG.DOCUMENTS.header.overview, onClick });

		this.bindHandles();
		this.props.fetchDocuments();
	}

	componentWillReceiveProps(props) {
		for(let key in this.state) {// eslint-disable-line
			if (props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

	handleSearch(value) {
		this.setState({ filteredItems: undefined });
		if (value) {
			const re = new RegExp(value, 'gi');
			this.setState({ filteredItems: this.state.items.filter(item => item.name.match(re)) });
		}

	}
	handleEdit(uuid) {
		this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.CREATE_DOCUMENTS}/${uuid}`);
	}
	handleDelete(id) {
		const foundItem = this.state.items.find(item => item.uuid === id);
		this.setState({
			deleteName: foundItem.name || id,
			confirmPopupOpen: true,
			pendingDeleteId: id,
		});
	}
	handleConfirm() {
		this.props.removeDocument(this.state.pendingDeleteId);
		this.setState({ confirmPopupOpen: false, pendingDeleteId: undefined });
	}
	handleCancel() {
		this.setState({ confirmPopupOpen: false, pendingDeleteId: undefined });
	}

	render() {
		const popupText = `Weet u zeker dat u ${this.state.deleteName} permanent wilt verwijderen?`;
		return (
			<div className="layout-cms--content-body layout-cms--content-body-grey">
				<OCmsTable
					columns={CMS_CONFIG.DOCUMENTS.table.columns}
					items={this.state.filteredItems || this.state.items}
					isFetching={this.state.isFetching}
					onSearch={this.handleSearch}
					onEdit={this.handleEdit}
					onDelete={this.handleDelete}
				/>
				<OConfirmPopup
					title="Bevestiging"
					text={popupText}
					confirmLabel="Ja"
					cancelLabel="Nee"
					open={this.state.confirmPopupOpen}
					onCancel={this.handleCancel}
					onConfirm={this.handleConfirm}
				/>
			</div>
		);
	}
}

DocumentOverviewPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	fetchDocuments: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	fetchDocuments,
	removeDocument,
})(DocumentOverviewPage)));



// WEBPACK FOOTER //
// ./src/CMS/document-overview.js